import { Injectable } from '@angular/core';
import { catchError } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { ActivatedRouteSnapshot } from '@angular/router';
import * as _ from 'lodash';
import { ImportService } from '@app/core/services/import.service';

@Injectable({ providedIn: 'root' })
export class MissingInvoiceNumberContentResolver  {
  constructor(private importService: ImportService) { }

  resolve(route: ActivatedRouteSnapshot): Observable<Blob> | Promise<Blob> | Blob {
    const id = route.params.id;
    return this.importService
      .getMissingInvoiceNumberDocumentContent(id)
      .pipe(catchError(_ => of(null)));
  }
}
